<template>
  <div class="page-header">
    <p class="title has-text-weight-bold">Revendedor</p>
    <p class="subtitle">Faça aqui a gestão dos seus clientes.</p>
  </div>
  <div class="table-title">
    <p class="is-size-5 has-text-weight-semibold">As suas empresas</p>
  </div>
  <CompaniesTable :companies="companies"></CompaniesTable>
</template>

<script>
import CompaniesTable from "@/components/tables/CompaniesTable";

export default {
  name: "ResellerCompanies",
  components: {CompaniesTable},
  computed: {
    companies() {
      return this.$store.getters.resellerCompanies;
    }
  },
  mounted() {
    this.$store.dispatch('fetchResellerCompanies');
    this.$store.commit('context','resellercompanies')
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 16px;
}

.title {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 16px;
}

.subtitle {
  color: var(--text-secondary);
  margin-top: 20px;
}

.table-title {
  margin-top: 32px;
  margin-bottom: 16px;
}
</style>
